module.exports = __webpack_public_path__ + "img/dot-black.c5c410f5.svg";